import type { PracticeContactViewModel } from 'chaika-types';

export function hasTelegramLink({ telegramLink }: PracticeContactViewModel): boolean {
    return !!telegramLink && telegramLink.length > 0;
}

export function getPracticeTelegramLink(practices: PracticeContactViewModel[]): string | undefined {
    return practices.find(hasTelegramLink)?.telegramLink;
}
